"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _PanelSocialButtons = require("./PanelSocialButtons.css");

var _PanelSocialButtons2 = _interopRequireDefault(_PanelSocialButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//     

var PanelSocialButtons = function (_React$PureComponent) {
	_inherits(PanelSocialButtons, _React$PureComponent);

	function PanelSocialButtons() {
		_classCallCheck(this, PanelSocialButtons);

		var _this = _possibleConstructorReturn(this, (PanelSocialButtons.__proto__ || Object.getPrototypeOf(PanelSocialButtons)).call(this));

		_this.state = {};
		return _this;
	}

	//getEncodedUrlApp = () => encodeURI(window.location.href);


	_createClass(PanelSocialButtons, [{
		key: "getEncodedUrlApp",
		value: function getEncodedUrlApp() {
			var url = encodeURI(window.location.href);
			url = url.replace(/#/g, "%23");
			return url;
		}
	}, {
		key: "renderButtons",
		value: function renderButtons() {

			var itemH = [];

			if (this.props.layoutoptions.twitter) {
				itemH.push(_react2.default.createElement(
					"a",
					{ key: itemH.length, target: "blank", href: this.props.layoutoptions.urltwitter + "&text=" + this.props.layoutoptions.title + " " + this.props.layoutoptions.users + "&hashtags=" + this.props.layoutoptions.hashtags + "&url=" + this.getEncodedUrlApp() },
					_react2.default.createElement(_semanticUiReact.Button, { circular: true, color: "blue", inverted: true, icon: "twitter" })
				));
			}

			if (this.props.layoutoptions.facebook) {
				itemH.push(_react2.default.createElement(
					"a",
					{ key: itemH.length, target: "blank", href: "" + this.props.layoutoptions.urlfacebook + this.getEncodedUrlApp() },
					_react2.default.createElement(_semanticUiReact.Button, { circular: true, color: "blue", inverted: true, icon: "facebook" })
				));
			}

			return itemH;
		}
	}, {
		key: "render",
		value: function render() {

			var panelStyle = this.props.isEditor ? _PanelSocialButtons2.default.panelSocialButtons : _PanelSocialButtons2.default.panelSocialButtonsVisor;

			return _react2.default.createElement(
				"div",
				{ className: panelStyle, id: "panelInfo" },
				_react2.default.createElement(
					_semanticUiReact.List,
					{ size: "tiny" },
					this.renderButtons()
				)
			);
		}
	}]);

	return PanelSocialButtons;
}(_react2.default.PureComponent);

exports.default = PanelSocialButtons;


PanelSocialButtons.propTypes = {
	layoutoptions: _propTypes2.default.object,
	thematicoptions: _propTypes2.default.array,
	isEditor: _propTypes2.default.bool
};
